export default __webpack_public_path__ + "static/media/companys_actual.ba43f020.png";